import { BrowserRouter as Router, Switch } from "react-router-dom";
import Dashboard from "../containers/Dashboard";
import LoginScreen from "../pages/LoginScreen";
import { useAppSelector } from "../store/hooks";
import { PrivateRoute } from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import TerminosCondicionesPage from "../pages/TerminosCondicionesPage";

export const AppRouter = () => {
  const { isLogged } = useAppSelector((state) => state.auth);

  return (
    <Router>
      <div>
        <Switch>
          <PublicRoute
            exact
            path="/login"
            component={LoginScreen}
            isAuthenticated={isLogged}
          />
          <PublicRoute
            exact
            path="/terminos-condiciones"
            component={TerminosCondicionesPage}
            isAuthenticated={false}
          />
          <PrivateRoute
            path="/"
            component={Dashboard}
            isAuthenticated={isLogged}
          />
        </Switch>
      </div>
    </Router>
  );
};
